const data=[
    {
      id:1,
      poster:"images/PythonClasses.png",
      url:"https://docs.google.com/forms/d/e/1FAIpQLScuGTwiRA75i60-yY918yxCNKKdU9_RXG6sziC2JZpdzYDP2A/viewform",
      description:"Register"  
    },
    {
      id:2,
      poster:"images/log.png",
      url:"#",
      description:"Coming Soon" 
      },
      {
        id:3,
        poster:"images/log.png",
        url:"#",
        description:"Coming Soon" 
        },
        {
          id:4,
          poster:"images/log.png",
          url:"#",
          description:"Coming Soon" 
          }

];

export default data;